import { create } from 'zustand';
import axiosInstance from '../services/axiosInstance';

const useCodingDashboardStore = create((set) => ({
  summary: {},
  heatmap: [],
  trend: [],
  recentActivity: [],
  loading: false,
  error: null,

  async fetchCodingDashboard() {
    set({ loading: true, error: null });
    try {
      const response = await axiosInstance.get('/student/dashboard/coding');
      const data = response?.data || {};

      set({
        summary: data?.summary || {},
        heatmap: Array.isArray(data?.heatmap) ? data.heatmap : [],
        trend: Array.isArray(data?.trend) ? data.trend : [],
        recentActivity: Array.isArray(data?.recentActivity) ? data.recentActivity : [],
        loading: false,
      });

      return data;
    } catch (err) {
      const message =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err?.message ||
        'Failed to load coding dashboard';
      set({ error: message, loading: false });
      throw err;
    }
  },
}));

export default useCodingDashboardStore;
